// Aquí están los thunks relacionados con el registro de usuarios
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";
import {
    startConfirmation,
    confirmSuccess,
    confirmFailure,
    resendCodeSuccess,
    resendCodeFailure 
} from "./confirmSlice";

/**
 * 📝 CONFIRM — Envía datos de confirmación al backend
 */
export const confirmUser = createAsyncThunk(
  "confirm/user",
  async ({ email, code }, { dispatch, rejectWithValue }) => {
    dispatch(startConfirmation());
    try {
        const { data } = await api.post("/auth/confirm-user", { email, code });
        dispatch(confirmSuccess());
        return data;
    } catch (error) {
        dispatch(confirmFailure(error.response?.data || error.response?.data?.message || "Error de confirmación"));
        return rejectWithValue(error.response?.data || error.response?.data?.message || "Error de confirmación");
    }
  }
);

export const resendConfirmationCode = createAsyncThunk(
    "confirm/resendCode",
    async ({ email }, { dispatch, rejectWithValue }) => {
        dispatch(startConfirmation());
        try {
            const { data } = await api.post("/auth/resend-code", { email });
            dispatch(resendCodeSuccess());
            return data;
        } catch (error) {
            dispatch(resendCodeFailure(error.response?.data || error.response?.data?.message || "Error al reenviar el código"));
            return rejectWithValue(error.response?.data || error.response?.data?.message || "Error al reenviar el código");
        }
    }
);